export class Banco {}
